export default function ($scope, $uibModalInstance) {
    'ngInject';
    $scope.T = $scope.$root.T;

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}



// WEBPACK FOOTER //
// ./src/app/views/app.privacy/appPrivacyCtrl.js